// Centralized domain error classes.
// Add new domain-specific errors here to keep a single source of truth.

export class PaymentError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PaymentError';
  }
}

export class EnrollmentError extends Error {
  declare cause?: unknown;

  readonly statusCode?: number;
  readonly details?: string;

  constructor(message: string, options?: { statusCode?: number; details?: string; cause?: unknown }) {
    super(message);
    this.name = 'EnrollmentError';
    this.statusCode = options?.statusCode;
    this.details = options?.details;

    if (options?.cause !== undefined) {
      this.cause = options.cause;
    }
  }
}

export class MitIDError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MitIDError';
  }
}

export class LicenseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LicenseError';
  }
}

export class EconomyApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EconomyApiError';
  }
}

export class NewsletterError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NewsletterError';
  }
}

export class RedisError extends Error {
  declare cause?: unknown;

  constructor(message: string, options?: { cause?: unknown }) {
    super(message);
    this.name = 'RedisError';

    if (options?.cause !== undefined) {
      this.cause = options.cause;
    }
  }
}

export class BuildError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BuildError';
  }
}
